<template>
  <v-col
    class="pa-0"
  >
    <h2>Delivery Data</h2>
    <br>
    Discrepancy Dashboard
    <br>
    Pacing Dashboard
  </v-col>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex'
//
// const { mapState } = createNamespacedHelpers('delivery')

export default {
  name: 'Delivery',
}
</script>
